import * as contentful from 'contentful';
import { config } from './config';

const client = contentful.createClient({
  accessToken: config.accessToken,
  host: config.host,
  resolveLinks: true,
  space: config.space,
});

const previewClient = contentful.createClient({
  accessToken: config.previewAccessToken,
  host: config.previewHost,
  resolveLinks: true,
  space: config.space,
});

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return {
    client,
    previewClient,
  };
})();
